import React from "react";
import { Box, Container } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import useHero from "../hooks/useHero";

const HeroSection = () => {
  const { data: heroData, isLoading } = useHero();

  if (isLoading || !heroData?.success) {
    return (
      <Box
        sx={{
          width: "100%",
          height: { xs: "400px", md: "740px" },
          mb: 5,
          background:
            "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
          backgroundSize: "200% 100%",
          animation: "shimmer 1.5s infinite",
          "@keyframes shimmer": {
            "0%": { backgroundPosition: "200% 0" },
            "100%": { backgroundPosition: "-200% 0" },
          },
        }}
      />
    );
  }

  const hasVideo = heroData.banner_video_url;
  const hasImages =
    heroData.banner_image_urls && heroData.banner_image_urls.length > 0;

  if (!hasVideo && !hasImages) {
    return null;
  }

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <Container
        sx={{
          padding: {
            sm: "30px 16px !important",
            md: "30px 60px !important",
          },
          maxWidth: "1440px !important",
        }}>
        {hasVideo ? (
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: "100%",
              height: "740px",
              objectFit: "cover",
              display: "block",
            }}>
            <source src={heroData.banner_video_url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            pagination={{ clickable: true, dynamicBullets: true }}
            loop={heroData.banner_image_urls.length > 1}
            style={{
              width: "100%",
              height: "540px",
              "--swiper-pagination-color": "#000000",
              "--swiper-pagination-bullet-inactive-color": "#CCCCCC",
              "--swiper-pagination-bullet-inactive-opacity": "1",
              "--swiper-pagination-bullet-size": "10px",
              "--swiper-pagination-bullet-horizontal-gap": "6px",
            }}>
            {heroData.banner_image_urls.map((imageUrl, index) => (
              <SwiperSlide key={index}>
                <img
                  src={imageUrl}
                  alt={`Hero banner ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "540px",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </Container>
    </Box>
  );
};

export default HeroSection;
